import React, { useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../header";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../../AuthContext";
import useAuth from "../../Auth";
const Layout = ({ children }) => {
  const PATHS = ["/games", "/score", "/playgame", "/match"];
  const location = useLocation();
  const {
    setErrorState,
    errorState,
    ErrorHandler,
    isAuthenticated,
    value,
    isWeb3Enabled,
  } = useAuthContext();
  const { loading } = useAuth();
  useEffect(() => {
    console.log("isweb3enabled", typeof window.ethereum);
    if (isWeb3Enabled) {
      setTimeout(() => {
        ErrorHandler();
      }, 1000);
    }
    if (typeof window.ethereum === "undefined") {
      setTimeout(() => {
        ErrorHandler();
      }, 1000);
    }
    window.scrollTo(0, 0);
  }, [location, isWeb3Enabled]);
  let type = 0;
  if (
    PATHS.includes(location.pathname) ||
    location.pathname.includes("/playgame")
  ) {
    type = 1;
  }
  console.log("loading", loading);
  return (
    <>
      {location.pathname === "/404" ? "" : <Header type={type} />}
      {location.pathname === "/games" ? <Sidebar /> : ""}
      {children}
    </>
  );
};

export default Layout;
